import { render, staticRenderFns } from "./LabFormulaOfHydrate.vue?vue&type=template&id=32e2ae17&"
import script from "./LabFormulaOfHydrate.vue?vue&type=script&lang=js&"
export * from "./LabFormulaOfHydrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports